import React, { useState, useEffect } from "react";
import { useIntl } from 'react-intl';
import { IRegras } from "../../interfaces/IRegras";
import RegrasService from "../../services/RegrasService";
import Swal from 'sweetalert2';
import RegrasModal from "./RegrasModal";
import { BotaoAdicional } from "./DocumentosRegras";
import DocumentosRegrasTabela from "./DocumentosRegrasTabela";
import { IDocumentos } from "../../interfaces/IDocumentos";

function Regras({ carregando, titulo, botaoAdicional, regras, setRegras, documentos }: { carregando: boolean, titulo: React.Dispatch<React.SetStateAction<string>>, botaoAdicional: React.Dispatch<React.SetStateAction<BotaoAdicional | undefined>>, regras: IRegras[] | undefined, setRegras: React.Dispatch<React.SetStateAction<IRegras[] | undefined>>, documentos: IDocumentos[] | undefined }) {
    
  const intl = useIntl();
  const [regraSelecionada, setRegraSelecionada] = useState<IRegras>({} as IRegras);
  const [modalTitle, setModalTitle] = useState<string>('');
  const [showModal, setShowModal] = useState<boolean>(false);
  const [carregado, setCarregado] = useState<boolean>(false);
  const columns = [
    {
      name: 'Nome',
      selector: (row: IRegras) => row['nome'],
      sortable: true,
    },
    {
      name: 'Código',
      selector: (row: IRegras) => row['codigo'],
      sortable: true,
    },
    {
      name: 'Ações',
      cell: (row: IRegras) => <AcoesRegra excluirRegra={excluirRegra} editarRegra={(regra: IRegras) => {
          setModalTitle('Editar Regra');
          setRegraSelecionada(regra);
          toggleModal();
      }} regra={row} />
    }
  ];

  useEffect(() => {
    setCarregado(carregando)
  }, [carregando])

  useEffect(() => {
    titulo(intl.formatMessage({ id: 'MENU.REGRAS' }));
    botaoAdicional({
      acao: () => {
        setModalTitle('Adicionar Regra');
        setRegraSelecionada({} as IRegras);
        toggleModal();
      },
      texto: 'ADICIONAR'
    })

    if (!regras) {
      setTimeout(async () => {
        await carregarInformacoes();
      }, 1000)
    } else {
      setCarregado(true);
    }

    //eslint-disable-next-line
  }, [])

  function AcoesRegra({ regra, excluirRegra, editarRegra }: { regra: IRegras, excluirRegra: (regra: IRegras) => void, editarRegra: (regra: IRegras) => void }) {
    return <div data-tag="allowRowEvents">
      <i onClick={() => { editarRegra(regra) }} className="fas fa-edit fs-1" style={{ color: '#5E6397', fontWeight: 'normal', cursor: 'pointer' }}/>
      <i onClick={() => { excluirRegra(regra) }} className="fas fa-trash-alt fs-1" style={{ color: '#5E6397', marginLeft: '20px', fontWeight: 'normal', cursor: 'pointer' }}/>
    </div>
  }

  async function carregarInformacoes() {
    setCarregado(false);
    await RegrasService.obterTodos(x => setRegras(x));
    setCarregado(true);
  }

  function toggleModal(recarregarInformacoes?: boolean): void {
    if (recarregarInformacoes) {
      carregarInformacoes();
    }

    setShowModal(!showModal);

    if (showModal) {
      setTimeout(() => { setRegraSelecionada({} as IRegras) }, 300)
    }
  }

  async function excluirRegra(regra: IRegras) {
    const swalWithBootstrapButtons = Swal.mixin({
      customClass: {
        confirmButton: 'btn btn-modal-excluir ms-5',
        cancelButton: 'btn btn-modal-cancelar'
      },
      buttonsStyling: false
    });
    const result = await swalWithBootstrapButtons.fire({
      title: 'Excluir Regras',
      text: `Você realmente deseja excluir essa regra?`,
      showCancelButton: true,
      cancelButtonText: 'Cancelar',
      confirmButtonText: `Excluir`,
      reverseButtons: true
    });

    if (result.isConfirmed) {
      await RegrasService.excluir(regra.id, () => setRegras(regras?.filter(x => x.id !== regra.id)), 'Regra excluída com sucesso');
    }
  }

  return <>
    <RegrasModal regra={regraSelecionada} title={modalTitle} show={showModal} toggleModal={toggleModal} documentos={documentos ?? []} />

    { carregado ? <DocumentosRegrasTabela colunas={columns} itens={regras ?? []} textoNenhumItem="Não existem nenhuma Regra para ser exibida" /> : <p>Carregando...</p> }
  </>
};

export default Regras;